/**
 * PETT returns a confidence score in the interval [0, 1] for each phoneme.
 * This threshold defines from which confidence score the phoneme can be
 * considered as correct
 */
export const THRESHOLD_PHONOME_VALID_SCORE: number = (() => {
  if (process.env.VUE_APP_PETT_PHONEME_CORRECT_THRESHOLD) {
    return parseFloat(process.env.VUE_APP_PETT_PHONEME_CORRECT_THRESHOLD);
  }

  return 0.6;
})();

/**
 * Number of allowed consecitive PETT errors before the answer is marked as
 * "incorrect"
 */
export const THRESOLD_PETT_ERROR_COUNT: number = (() => {
  if (process.env.VUE_APP_PETT_ERROR_COUNT_THRESHOLD) {
    return parseInt(process.env.VUE_APP_PETT_ERROR_COUNT_THRESHOLD);
  }

  return 2;
})();

/**
 * Name of the S3 bucket to store the pronunciation drills utterrances. Ensure
 * that the AWS user has `PUT` permission to write in this bucket
 */
export const DRILL_PRONUNCIATION_S3_BUCKET_NAME = (() => {
  if (process.env.VUE_APP_DRILL_PRONUNCIATION_S3_BUCKET_NAME) {
    return process.env.VUE_APP_DRILL_PRONUNCIATION_S3_BUCKET_NAME;
  }

  return "tt-drills-pronunciation";
})();

/**
 * Region of the S3 bucket to store the pronunciation drills uterrances. Ensure
 * that value is not overriden by another region (e.g.: default value)
 */
export const DRILL_PRONUNCIATION_S3_BUCKET_REGION = (() => {
  if (process.env.VUE_APP_DRILL_PRONUNCIATION_S3_BUCKET_REGION) {
    return process.env.VUE_APP_DRILL_PRONUNCIATION_S3_BUCKET_REGION;
  }

  return "ap-northeast-1";
})();

/**
 * Folder path without leading and trailing slashes to store the pronunciation
 * drills uterrances in the S3 bucket
 */
export const DRILL_PRONUNCIATION_S3_BUCKET_FOLDER = (() => {
  if (process.env.VUE_APP_DRILL_PRONUNCIATION_S3_BUCKET_FOLDER) {
    return process.env.VUE_APP_DRILL_PRONUNCIATION_S3_BUCKET_FOLDER;
  }

  return "tt-web/local";
})();

export const DRILL_PRONUNCIATION_S3_UPLOAD_ID_POOL =
  process.env.VUE_APP_AWS_S3_UPLOAD_ID_POOL || "";

/**
 * Timeout for recording a pronunciation drill answer, in milleseconds
 */
export const DRILL_PRONUNCIATION_TIMEOUT = 10000;

/**
 * Maximum length allowed for a translation, including intermediate comma
 */
export const DRILL_VOCABULARY_TRANSLATION_MAX_LENGTH = 15;
